import { getNumOfDaysFromDates } from "./getLastNdays";
import {
  extractFeedbackData as dataExtract,
  reduceExtractedData as dataReducer,
  dataFormatter,
} from "./lineChartHelper";
import {
  branchBasedFeedbackDataFilter,
  getActiveBranchIds1,
} from "./multipleBranch/getActiveBranchId";
/*
steps involved would be 
1st data extration from feedback data. ie staff property and date from feedback.

2nd data reducer to be suitabe for line chart .

3rd step will be to modify reduced data in the formate prescribed by chartj js library
*/

export function generateStaffData(numOfDays, data) {
  // expects number of days to get data reduced from feedbackdata

  // i will filter data branchwise here and then supply to diff functions
  if (data == null || data.length == 0) {
    return null;
  }
  // console.log(data);
  let activeBranches = getActiveBranchIds1();
  let superData = [];
  activeBranches.forEach((bId) => {
    let obj = {
      bId: bId,
      data: [],
      tableData: [],
    };
    const bData = branchBasedFeedbackDataFilter(data, bId);
    console.log("bData", bData);
    if (bData == null || bData.length == 0) return;
    const d1 = dataExtract(bData, numOfDays);
    console.log("d1", d1);
    if (d1 == null) return;
    const d2 = dataReducer(d1, bId);
    console.log("d2", d2);
    if (d2 == null || d2.length == 0) return;
    const d3 = dataFormatter(d2);
    console.log("d3", d3);
    if (d3 == null) return;

    obj.data.push(d3.data);
    obj.tableData = d3.tableData;
    superData.push(obj);
  });
  console.log("superData");
  console.log(superData);

  return superData.length > 0 ? superData : null;
}
